import { Box, Container, Typography } from '@mui/material'
import React from 'react'

const boldText = {
	fontWeight: 800,
	fontSize: 18,
}

const BlocBorderLeft = ({ title, info1, info2, info3, color, ml }) => {
	if (color) boldText.color = color

	return (
		<Box sx={{ textAlign: 'left', mt: 3 }}>
			<Typography
				component="h6"
				sx={{ mb: 1.5, color: color || 'text.primary', fontSize: 14, fontWeight: 400 }}
			>
				{title}
			</Typography>
			<Container
				sx={(theme) => ({
					borderLeft: `4px solid ${color || '#1D1D1B'}`,
					[theme.breakpoints.up('md')]: {
						p: theme.spacing(0, 0, 0, 2),
						ml,
					},
					'& .MuiTypography-root': {
						[theme.breakpoints.down('md')]: {
							fontSize: 16,
						},
					},
				})}
			>
				<Typography sx={boldText} dangerouslySetInnerHTML={{ __html: info1 }} />
				<Typography sx={boldText} dangerouslySetInnerHTML={{ __html: info2 }} />
				{info3 && <Typography sx={boldText} dangerouslySetInnerHTML={{ __html: info3 }} />}
			</Container>
		</Box>
	)
}

export default BlocBorderLeft
